import React from 'react'
import { Button, Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom' // ✅ Correct hook

function AuthButtos() {
  const navigate=useNavigate();
    const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='mb-5'>
<Container>
  <Row>
    <div className='d-flex justify-content-center'>
      <div className='w-50  d-flex justify-content-center'>
      <Button className='mx-3 bg_main border-0 p-3 px-5'onClick={()=>navigate("/registration-conditions")}>
        {currentLocal.home.registrationform}
      </Button>
      <Button className='border-0 p-3 px-5'onClick={()=>navigate("/expenses")}>
{currentLocal.home.Tuitionfees}
      </Button>
    </div>
    </div>
  </Row>
</Container>
    </div>
  )
}

export default AuthButtos